// extracted by mini-css-extract-plugin
export default {"modalWrap":"style_modalWrap__vjAnW","name_item":"style_name_item__oKrMF","description":"style_description__iuX12","avatar":"style_avatar__8b1AP"};